import * as Sentry from '@sentry/react';
import { getAuth } from 'firebase/auth';
import { collection, doc, serverTimestamp, setDoc } from 'firebase/firestore';

import { AuditLog } from '@superfunnel/types/audit-log';

import { db } from '../Firebase';
import { removeUndefinedFields } from '../utils/firestore';

export const auditLogColRef = (accountId: string) =>
  collection(db, `accounts/${accountId}/auditLogs`);

export const createAuditLog = async (
  accountId: string,
  data: Pick<
    AuditLog,
    | 'action'
    | 'changes'
    | 'context'
    | 'entity'
    | 'entityId'
    | 'entityName'
    | 'name'
  >,
) => {
  const docRef = doc(auditLogColRef(accountId));

  const _data = removeUndefinedFields({
    ...data,
    id: docRef.id,
    createdAt: serverTimestamp(),
    createdBy: getAuth().currentUser?.uid ?? 'unknown',
  });

  return setDoc(docRef, _data).catch((error) => {
    console.error('Error adding document: ', error);
    Sentry.captureException(error);
  });
};
